/**
 * Converts linebreaks within a string into HTML line-breaks
 * @param {string} text - A text to be transformed
 * @return {string} The transformed text
 */
export default function linebreakFilter(text) {
    return text.replace(/\n\r?/g, '<br>');
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/filters/linebreak/index.js